import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { FrameContainerModel } from '../../../../../../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class FrameFileService extends BaseApiTemplateService<FrameContainerModel> {
  endpointSubPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'frame/file-hdr';
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointSubPath + '/backoffice-ep';
    this.endpoint_path = this.endpointSubPath + '/backoffice-ep';
    this.httpClient = http;
  }
  
  createFrameWithFile(formData: FormData, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  updateFrameWithFile(formData: FormData, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  updateFile(formData: FormData, hdrGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path + '/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/' + hdrGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getFile(guid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path + '/file/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
}